import "bootstrap";
import * as Sentry from "@sentry/vue";
import { Api, DisplayApi, LabHubApi } from "@helpers/api";
import App from "./App.vue";
import Pusher from "pusher-js";
import VueAxios from "vue-axios";
import VueSweetalert2 from "vue-sweetalert2";
import { createApp } from "vue";
import { createI18nInstance } from "@helpers/i18n";
import { createPinia } from "pinia";
import eventbus from "./eventbus";
import registerComponents from "./registerComponents";
import { router } from "@router/router";
import { setStorage } from "@helpers/storage";
import updateAppVersion from "@helpers/version";
import { useAppStore } from "@stores/appStore";
import { useUserStore } from "./stores/userStore";
import permissionPlugin from "./plugins/permissionPlugin";
import { useEditorStore } from "./stores/editorStore.js";
import { useDisplayStore } from "./stores/displayStore.js";

// Create vue app
const VueApp = createApp({
    router,
});

const app = VueApp;

// Create i18n instance with options
const i18n = await createI18nInstance("nl");
app.config.globalProperties.i18n = i18n;

// Environment variables
// eslint-disable-next-line no-undef
const ENV_VAR_ = ENV_VAR;
app.config.globalProperties.ENV = ENV_VAR_;

// Register pinia
const pinia = createPinia();
pinia.use(Sentry.createSentryPiniaPlugin());
app.use(pinia);

// Register stores
const userStore = useUserStore();
const appStore = useAppStore();
const displayStore = useDisplayStore();

// Sentry
if (ENV_VAR_.enviroment === "production") {
    Sentry.init({
        app,
        dsn: "https://acbfe887218fbb946113cfc11b7c3638@sentry.normec.app/5",
        integrations: [
            Sentry.replayIntegration({
                blockAllMedia: false,
                maskAllText: false,
            }),
            Sentry.browserTracingIntegration(),
        ],
        release: ENV_VAR_.version,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
        sendDefaultPii: true,
    });
}

// Setup appstore
appStore.setup(ENV_VAR_);

// Setup userstore
userStore.initialize();

// Register components
VueApp.component("App", App);
registerComponents(VueApp);

const options = {
    buttonsStyling: false,
    customClass: {
        cancelButton: "btn btn-danger mx-2",
        confirmButton: "btn btn-success mx-2",
    },
};

// User permission plugin
app.use(permissionPlugin);

// Use Router and Api
VueApp.use(VueSweetalert2, options);
VueApp.use(i18n);
VueApp.use(router);
VueApp.use(VueAxios, { api: Api, labHubApi: LabHubApi, displayApi: DisplayApi });

// Setup displaystore
displayStore.load();

// Setup editor store
const editorStore = useEditorStore();
editorStore.setup(app.config.globalProperties.$swal, i18n);

// Websockets
window.Pusher = Pusher;

// Version management
setStorage("app-version", ENV_VAR_.version);
eventbus.on("set-version", updateAppVersion);

// Mount app
VueApp.mount("#app");
